import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Field, reduxForm } from 'redux-form'

import { Row, Col } from 'flexbox'

import { DropDownForm } from 'controls/DropDown'
import { InputForm } from 'controls/Input'

import { image } from 'services'
import { required } from 'services/validators'

import { reasons } from '../calendarConfig'
import { appointmentStatus } from './styles'

const options = reasons
  .filter(r => r.type === 'VALUATION_FAILURE')
  .map(r => ({ value: r.id, label: r.name }))

class AppointmentStatus extends Component {
  static propTypes = {
    eventVisited: PropTypes.bool.isRequired
  }

  render() {
    const { handleSubmit } = this.props
    return (
      <form className="login-container" onSubmit={handleSubmit}>
        {!this.props.eventVisited && (
          <Row>
            <Col xs={12}>
              <Field
                className="form-input-margin"
                component={DropDownForm}
                name="reason"
                editable={false}
                hideResetButton={true}
                placeholder="Selecciona un motivo"
                options={options}
              />
            </Col>
          </Row>
        )}

        <Row>
          <Col xs={12}>
            <Field
              className="form-input-margin"
              name="comment"
              id="comment"
              component={InputForm}
              placeholder="Información adicional"
            />
          </Col>
        </Row>
        <style jsx>{ appointmentStatus }</style>
      </form>
    )
  }
}

const formConfig = {
  form: 'appointmentStatus'
}

const Form = reduxForm(formConfig)(AppointmentStatus)

export default class extends Component {
  static propTypes = {
    eventVisited: PropTypes.bool.isRequired,
    onChangeSaveData: PropTypes.func.isRequired
  }

  validate = values => {
    let errors = {}
    if (!values.reason) {
      errors.reason = 'Una razón es necesaria'
    }
    if (Object.keys(errors).length === 0) {
      this.props.onChangeSaveData({
        reason: values.reason.value,
        comment: values.comment
      })
    }
    return errors
  }

  render() {
    return (
      <Form validate={this.validate} eventVisited={this.props.eventVisited} />
    )
  }
}
